<template>
  <!--新增普通模板-->
  <div class="general-wrap">
    <h1 class="com-title com-ht" style="margin-bottom: 20px;">
      <i></i>设置新增模板<span class="ms">/ 设置合同固定条款，智能生成合同信息</span>
    </h1>
    <el-container class="general">
      <el-main class="main" v-loading="loadingTpl">
        <tpl-editor ref="tplEditor"
                    @editorReadyCallback="handleEditorReadyCallback"
                    @change="handleChange"
                    @doubleclickPlaceholder="handeDoubleclickPlaceholder"
                    @clickPlaceholder="handleClickPlaceholder"
                    :insert-html="innerString"
                    :change-placeholder="valChange"
                    :del-placeholder="delInner"
                    :select-placeholder="currentOpVar.varName || ''"/>
      </el-main>

      <el-aside width="260px" class="aside">
        <h4>模板信息</h4>
        <el-form :model="tplFrm" ref="tplFrm" :rules="tplFrmRules" size="small" class="tpl-info">
          <el-form-item label="模板名称" prop="tplName">
            <el-input v-model="tplFrm.tplName" placeholder="模板名称" maxlength="30"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="tplFrmSubmit()" class="btn">保存模板</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="toShowEditTplVarDialog(false)" class="btn">添加变量</el-button>
          </el-form-item>
          <draggable :list="tplVarList" @start="dragging=true" @end="dragging=false">
            <template v-if="tplVarList.length" v-for="(item, i) in tplVarList">
              <div :key="i" class="val-item">
                <p @click="selectCurrentOpVar(item.varName)" @dblclick="toShowEditTplVarDialog(true)" :key="i" :class="currentOpVar.varName == item.varName ? 'active' : ''">
                  {{item.varName}}
                  <i @click="delTplVar(item)" class="el-icon-circle-close del"></i>
                </p>
              </div>
            </template>
          </draggable>
        </el-form>
      </el-aside>

      <el-dialog :title="editTplVarDialogName" :visible.sync="showEditTplVarDialog" width="25%">
        <el-form :model="tplVarFrm" ref="tplVarFrm" :rules="tplVarFrmRules" class="val-form" size="small">
          <el-form-item label="变量名称" prop="varName">
            <el-input v-model="tplVarFrm.varName"/>
          </el-form-item>
          <el-form-item label="变量类型">
            <el-select v-model="tplVarFrm.varType" class="select">
              <el-option label="文本" :value="0"/>
              <el-option label="数字" :value="1"/>
              <el-option label="日期" :value="2"/>
              <el-option label="手机号码" :value="3"/>
              <el-option label="身份证号码" :value="4"/>
              <el-option label="营业执照号" :value="5"/>
              <el-option label="统一社会编码格式" :value="6"/>
              <el-option label="电子邮箱" :value="7"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="tplVarFrm.varIsMust" label="是否必填"/>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button @click="editTplVarSubmit" type="danger" class="btn">确认添加</el-button>
            <el-button @click="showEditTplVarDialog = false" class="btn">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </div>

</template>

<script>
  import draggable from 'vuedraggable';
  import TplEditor from '../../../components/tpl-editor';
  import {ApiMethods} from '@/assets/js/http-serve/http-methods';

  export default {
    data() {
      return {
        tplFrm: {tplId: '', tplName: '', serialNum: ''},
        tplFrmRules: {
          tplName: [
            {validator: this.$validator.required, trigger: 'change', message: '模板名称不能为空'},
            {validator: this.$validator.regex, regex: /^(?![\s])(?!.*[\s]$).*$/, trigger: 'change', message: '变量名称前后不要留空白'},
            {validator: this.$validator.lengthRank, minLength: 2, maxLength: 30, trigger: 'change'}
          ]
        },
        editTplVarDialogName: '新增模板变量',
        tplVarList: [],
        showEditTplVarDialog: false,
        currentOpVar: {},
        tplVarFrm: {varName: '', varType: 0, varIsMust: false},
        varTypeEnum: [
          {
            label: ''
          }
        ],
        tplVarFrmRules: {
          varName: [
            {validator: this.$validator.required, trigger: 'change', message: '变量名称不能为空'},
            {validator: this.$validator.regex, regex: /^(?![\s])(?!.*[\s]$).*$/, trigger: 'change', message: '变量名称前后不要留空白'},
            {validator: this.$validator.lengthRank, minLength: 2, maxLength: 30, trigger: 'change'},
            {
              validator: (rule, val, callback) => {
                for (var key in this.tplVarList) {
                  if (this.tplVarList[key].varName == val && this.currentOpVar.varName != val) {
                    return callback('变量名称不能重复');
                  }
                }
                callback();
              }, trigger: 'change'
            }
          ]
        },
        valChange: {name: '', oldName: ''},
        innerString: null,
        delInner: '',
        dragging: false,
        loadingTpl: false
      };
    },
    mounted(){
      setTimeout(()=>this.$refs.tplFrm.resetFields())
    },
    methods: {
      handleEditorReadyCallback: function() {
        var _this = this;
        _this.tplFrm.tplId = _this.$route.query.tplId;
        if (_this.tplFrm.tplId) {
          _this.loadTpl(_this.tplFrm.tplId);
        }
      },
      loadTpl: function(tplId) {
        this.loadingTpl = true;
        var _this = this;
        ApiMethods.TemplateController.findTpl({tplId: tplId}).then(result => {
          if (result.success) {
            _this.tplFrm = result.data;
            _this.tplVarList = result.data.varList;
            _this.$refs.tplEditor.setData(_this.tplFrm.context);
          } else {
            _this.$message.error(result.description || this.$tip);
          }
        }).finally(() => {
          _this.loadingTpl = false;
        });
      },
      // 选择变量
      selectCurrentOpVar: function(name) {
        if (name) {
          this.currentOpVar = {};
          this.tplVarList.forEach(t => {
            if (t.varName === name) {
              return this.currentOpVar = JSON.parse(JSON.stringify(t));
            }
          });
        } else {
          this.currentOpVar = {};
        }
      },
      // placeholder 单击选中列表中的某个值
      handleClickPlaceholder: function(name) {
        if (!name || name === '') {
          this.currentOpVar = {};
        } else {
          this.selectCurrentOpVar(name);
        }
      },
      // placeholder 双击修改变量
      handeDoubleclickPlaceholder: function(name) {
        this.selectCurrentOpVar(name);
        this.toShowEditTplVarDialog(true);
      },
      // 编辑器内容变化处理
      handleChange: function(info) {
        this.tplFrm.context = info;
      },
      // 弹出变量表单
      toShowEditTplVarDialog: function(isUpd) {
        this.showEditTplVarDialog = true;
        if (isUpd) {
          this.tplVarFrm = JSON.parse(JSON.stringify(this.currentOpVar));
          this.editTplVarDialogName = '修改模板变量'
        } else {
          this.editTplVarDialogName = '新增模板变量'
          this.currentOpVar = {};
          this.tplVarFrm = {varName: '', varType: 0, varIsMust: false};
        }
        this.tplVarFrm.isUpd = isUpd;
      },
      editTplVarSubmit: function() {
        var _this = this;
        _this.$refs.tplVarFrm.validate((valid) => {
          if (valid) {
            if (_this.tplVarFrm.isUpd) {//编辑
              //修改editor里面的值
              _this.valChange = {name: _this.tplVarFrm.varName, oldName: _this.currentOpVar.varName};
              //修改变量列表的值
              for (var key in _this.tplVarList) {
                if (_this.tplVarList[key].varName === _this.currentOpVar.varName) {
                  _this.tplVarList[key] = _this.tplVarFrm;
                  break;
                }
              }
            } else {//新加
              _this.tplVarList.push(_this.tplVarFrm);
              _this.innerString = `[[${_this.tplVarFrm.varName}]] `;
            }
            _this.showEditTplVarDialog = false;
          }
        });
      },

      delTplVar: function(info) {
        this.tplVarList.forEach((t, i) => {
          if (t.varName === info.varName) {
            this.delInner = info.varName;
            return this.tplVarList.splice(i, 1);
          }
        });
      },

      tplFrmSubmit: function() {
        var _this = this;
        _this.$refs.tplFrm.validate((valid) => {
          if (valid) {
            var param = _this.tplFrm;
            const contextHtml = _this.$refs.tplEditor.editor.getData();
            _this.tplFrm.context = contextHtml;
            const document = _this.$refs.tplEditor.editor.document;
            if (document) {
              var contextText = document.getBody().getText().trim();
              if (!contextText || contextText.length < 1 || contextText === '') {
                return _this.$alert('请填写模板内容', '系统提示');
              }
            }
            if (!contextHtml || contextHtml === '') {
              return _this.$alert('模板内容不能为空', '系统提示');
            }

            _this.$refs.tplEditor.selectAllVar(function(vars) {
              var varList = [];
              if (_this.tplVarList && _this.tplVarList.length > 0) {
                for (var i = 0; i < _this.tplVarList.length; i++) {
                  var o = _this.tplVarList[i];
                  if (vars.has(o.varName)) {
                    varList.push(o);
                  }
                }
              }
              param.varList = JSON.stringify(varList);
              ApiMethods.TemplateController.operTpl(param).then(result => {
                if (result.success) {
                  _this.$alert('操作成功', '系统提示', {confirmButtonText: '确定', callback: action => { _this.$router.push({path: '/tpl/general'}); }});
                } else {
                  _this.$message.error(result.description || this.$tip);
                }
              });
            });
          }
        });
      }
    },
    created() {

    },
    components: {draggable, TplEditor},
    name: 'general',
    layout: ''
  };
</script>

<style lang="less" scoped>
  .general-wrap{
    background: #ffffff;
    padding-bottom: 20px;
  }

  .main {
    padding: 0 20px;
    /*height: calc(100vh - 320px);*/
  }

  .val-form {
    .select {
      width: 100%;
    }
    .btn {
      width: 100px;
    }
  }

  .aside {
    box-sizing: border-box;
    margin-right: 20px;
    display: table-cell;
    border: 1px solid #d7d7d7;
    background: #f8f8f8;

    .val-item {
      margin: 15px 0;
      clear: both;
      cursor: move;

      p {
        overflow: hidden;
        border-width: 1px 1px 1px 2px;
        border-style: dashed;
        border-color: #999999;
        line-height: 200%;
        padding-left: 10px;
        color: #999999;
      }

      .del {
        float: right;
        font-size: 18px;
        margin-top: 5px;
        margin-right: 5px;
        cursor: pointer;
      }
      p.active {
        border-color: #ec1c1c;
        color: #ec1c1c;
      }
    }

    .tpl-info {
      padding: 20px;

      .btn {
        width: 100%;
      }
    }

    h4 {
      font-size: 14px;
      color: #333333;
      font-weight: 500;
      line-height: 300%;
      background-color: #f2f2f2;
      text-align: center;
    }
  }

  /*/deep/ .cke_contents{*/
  /*  height: 500px !important;*/
  /*  */
  /*}*/
  /deep/ .cke_contents{
    height: calc(100vh - 420px) !important;
  }
</style>



// WEBPACK FOOTER //
// pages/tpl/add/general.vue